export enum UniversityDegreeType {
  JURIS_DOCTOR,
  BACHELOR_OR_ARTS,
  BACHELOR_OF_ARTS_AND_BACHELORS_OF_LAWS,
  BACHELOR_OF_BUSINESS_ADMINISTRATION_AND_BACHELOR_OF_LAWS,
  BACHELOR_OF_COMMERCE,
  BACHELOR_OF_COMMERCE_AND_BACHELOR_OF_LAWS,
  BACHELOR_OF_ECONOMICS_AND_BACHELOR_OF_LAWS,
  BACHELOR_OF_ENGINEERING_AND_BACHELOR_OF_LAWS,
  BACHELOR_OF_LAWS,
  BACHELOR_OF_SCIENCE,
  BACHELOR_OF_SCIENCES_AND_BACHELOR_OF_LAWS,
  BACHELOR_OF_SOCIAL_SCIENCES_AND_BACHELOR_OF_LAWS,
  MASTER_OF_ARTS,
  MASTER_OF_BUSINESS_ADMINISTRATION,
  MASTER_OF_EDUCATION,
  MASTER_OF_FINANCE,
  MASTER_OF_FINE_ARTS,
  MASTER_OF_LAWS,
  MASTER_OF_PUBLIC_ADMINISTRATION,
  MASTER_OF_SCIENCE,
  MASTER_OF_SOCIAL_WORK,
  DOCTORATE,
  DOCTOR_OF_DENTISTRY,
  DOCTOR_OF_MEDICINE,
  DOCTOR_OF_OSTEOPATHIC_MEDICINE,
  DOCTOR_OF_PHARMACY,
  OTHER,
}

export const UniversityDegreeTypeLabel = new Map<number, string>([
  [UniversityDegreeType.JURIS_DOCTOR, "Juris Doctor"],
  [UniversityDegreeType.BACHELOR_OR_ARTS, "Bachelor of Arts"],
  [
    UniversityDegreeType.BACHELOR_OF_ARTS_AND_BACHELORS_OF_LAWS,
    "Bachelor of Arts and Bachelors of Laws",
  ],
  [
    UniversityDegreeType.BACHELOR_OF_BUSINESS_ADMINISTRATION_AND_BACHELOR_OF_LAWS,
    "Bachelor of Business Administration (Law) and Bachelor of Laws (Double Degree)",
  ],
  [UniversityDegreeType.BACHELOR_OF_COMMERCE, "Bachelor of Commerce"],
  [
    UniversityDegreeType.BACHELOR_OF_COMMERCE_AND_BACHELOR_OF_LAWS,
    "Bachelor of Commerce and Bachelor of Laws",
  ],
  [
    UniversityDegreeType.BACHELOR_OF_ECONOMICS_AND_BACHELOR_OF_LAWS,
    "Bachelor of Economics and Bachelor of Laws",
  ],
  [
    UniversityDegreeType.BACHELOR_OF_ENGINEERING_AND_BACHELOR_OF_LAWS,
    "Bachelor of Engineering and Bachelor of Laws",
  ],
  [UniversityDegreeType.BACHELOR_OF_LAWS, "Bachelor of Laws"],
  [UniversityDegreeType.BACHELOR_OF_SCIENCE, "Bachelor of Science"],
  [
    UniversityDegreeType.BACHELOR_OF_SCIENCES_AND_BACHELOR_OF_LAWS,
    "Bachelor of Sciences and Bachelor of Laws",
  ],
  [
    UniversityDegreeType.BACHELOR_OF_SOCIAL_SCIENCES_AND_BACHELOR_OF_LAWS,
    "Bachelor of Social Sciences and Bachelor of Laws",
  ],
  [UniversityDegreeType.MASTER_OF_ARTS, "Master of Arts"],
  [
    UniversityDegreeType.MASTER_OF_BUSINESS_ADMINISTRATION,
    "Master of Business Administration",
  ],
  [UniversityDegreeType.MASTER_OF_EDUCATION, "Master of Education"],
  [UniversityDegreeType.MASTER_OF_FINANCE, "Master of Finance"],
  [UniversityDegreeType.MASTER_OF_FINE_ARTS, "Master of Fine Arts"],
  [UniversityDegreeType.MASTER_OF_LAWS, "Master of Laws"],
  [
    UniversityDegreeType.MASTER_OF_PUBLIC_ADMINISTRATION,
    "Master of Public Administration",
  ],
  [UniversityDegreeType.MASTER_OF_SCIENCE, "Master of Science"],
  [UniversityDegreeType.MASTER_OF_SOCIAL_WORK, "Master of Social Work"],
  [UniversityDegreeType.DOCTORATE, "Doctorate"],
  [UniversityDegreeType.DOCTOR_OF_DENTISTRY, "Doctor of Dentistry"],
  [UniversityDegreeType.DOCTOR_OF_MEDICINE, "Doctor of Medicine"],
  [
    UniversityDegreeType.DOCTOR_OF_OSTEOPATHIC_MEDICINE,
    "Doctor of Osteopathic Medicine",
  ],
  [UniversityDegreeType.DOCTOR_OF_PHARMACY, "Doctor of Pharmacy"],
  [UniversityDegreeType.OTHER, "Other"],
]);
